import React from 'react';
import { useFlags, usePrefs } from 'wsm-common-data';
import PaymentSelector from './PaymentSelector';
import PaymentSelectorLegacy from './PaymentSelectorLegacy';
import SpecialsDisplay from './SpecialsDisplay';
import StepCtas from './StepCtas';

const PaymentSelectorView = () => {
	const flags = useFlags();
	const { enableIncentives, showCTAs } = usePrefs();
	const enableStepConfig =
		flags['ws-track-my-offer-server-side-step-config'] || false;

	return (
		<>
			{enableStepConfig ? (
				<PaymentSelector key="track-my-offer-payment-selector" />
			) : (
				<PaymentSelectorLegacy key="track-my-offer-payment-selector" />
			)}
			{enableIncentives === 'true' && (
				<SpecialsDisplay key="track-my-offer-specials-display" />
			)}
			{showCTAs === 'true' && <StepCtas key="track-my-offer-ctas" />}
		</>
	);
};

export default PaymentSelectorView;
